var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "sidebar-block" } }, [
    _c("div", { staticClass: "go-sidebar" }, [
      _c("div", { staticClass: "go-sidebar-header" }, [
        _c("div", { staticClass: "go-sidebar-title" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("briefing.my-briefing.filter")) +
              "\n      "
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.briefingPageIdsSidebar.length <= 0,
                expression: "briefingPageIdsSidebar.length <= 0",
              },
            ],
            staticClass: "go-select-info",
            class: { disabled: true },
          },
          [
            _c(
              "button",
              {
                staticClass: "btn go-btn-check",
                class: { active: _vm.isViewAllReport },
                attrs: { type: "button" },
              },
              [_c("i", { staticClass: "go-icon-16 go-icon-check" })]
            ),
            _vm._v(" "),
            _c("p", [
              _vm._v(_vm._s(_vm.$t("briefing.my-report.side-bar.all"))),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.briefingPageIdsSidebar.length > 0,
                expression: "briefingPageIdsSidebar.length > 0",
              },
            ],
            staticClass: "go-select-info",
          },
          [
            _c("p", [
              _c("strong", { staticClass: "go-count" }, [
                _vm._v(_vm._s(_vm.briefingPageIdsSidebar.length || 0)),
              ]),
              _vm._v(
                _vm._s(_vm.$t("briefing.my-report.side-bar.select-item")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn go-btn-icon go-btn-close",
                attrs: { type: "button" },
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "go-tooltip-area go-toggle-off",
                    attrs: { "data-toggle": "tooltip", title: "선택 해제" },
                  },
                  [
                    _c("i", {
                      staticClass: "go-icon-18 go-icon-close",
                      on: { click: _vm.resetAll },
                    }),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "go-sidebar-body" }, [
        _c(
          "div",
          { staticClass: "go-sidebar-body-inner overflow-y-scroll" },
          [
            _c(
              "vue-custom-scrollbar",
              {
                staticClass:
                  "go-list-inner overflow-y-scroll customScroll csScrollPosition ps listWrapBoxMyReport",
                attrs: { settings: _vm.scrollSettings },
              },
              [
                _c("div", { staticClass: "go-panel" }, [
                  _c("div", { staticClass: "go-panel-body" }, [
                    _c("div", { staticClass: "go-list-wrap" }, [
                      _c(
                        "ul",
                        {
                          staticClass:
                            "go-card-sub-list go-card-topic go-card-select",
                        },
                        [
                          _c(
                            "li",
                            {
                              staticClass: "go-list-item go-list-all",
                              attrs: { "aria-selected": "false" },
                            },
                            [
                              _c(
                                "a",
                                {
                                  class: [
                                    "go-card-sub",
                                    {
                                      active:
                                        _vm.briefingPageIdsSidebar.includes(
                                          "reportNoBriefing"
                                        ),
                                    },
                                  ],
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.noBriefingFilter(
                                        "reportNoBriefing"
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("div", { staticClass: "go-card-img" }, [
                                    _c("i", {
                                      staticClass:
                                        "go-icon-24 go-icon-briefing-none",
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "go-card-body" }, [
                                    _c(
                                      "div",
                                      { staticClass: "go-card-title" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "briefing.my-report.side-bar.no-briefing"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn go-btn-check",
                                      class: {
                                        active:
                                          _vm.briefingPageIdsSidebar.includes(
                                            "reportNoBriefing"
                                          ),
                                      },
                                      attrs: {
                                        type: "button",
                                        "data-toggle": "button",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.noBriefingFilter(
                                            "reportNoBriefing"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "go-icon-16 go-icon-check",
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.briefingPages && !_vm.briefingPages.length
                            ? _c("div", { staticClass: "go-empty" }, [
                                _c("div", { staticClass: "go-icon-wrap" }, [
                                  _c("i", {
                                    staticClass:
                                      "go-icon-40 go-icon-alert-circle",
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "go-info-text" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "briefing.my-report.side-bar.no-briefing-filter"
                                      )
                                    )
                                  ),
                                ]),
                              ])
                            : _vm._l(_vm.briefingPages, function (item, index) {
                                return _c(
                                  "li",
                                  {
                                    key: index + item.bpId,
                                    staticClass: "go-list-item",
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        class: [
                                          "go-card-sub",
                                          {
                                            active:
                                              _vm.briefingPagesFilterSidebar.includes(
                                                item
                                              ),
                                          },
                                        ],
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.briefingFilter(item)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "go-card-img" },
                                          [
                                            _c("img", {
                                              attrs: { src: item.imageUri },
                                              on: { error: _vm.onImageError },
                                            }),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "go-card-body" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "go-card-title" },
                                              [
                                                _vm._v(
                                                  _vm._s(item.briefingPageName)
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "go-card-info" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "go-datetime",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatDateAgo(
                                                          _vm.moment(
                                                            item.createdDate
                                                          )
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass: "btn go-btn-check",
                                            class: {
                                              active:
                                                _vm.briefingPagesFilterSidebar.includes(
                                                  item
                                                ),
                                            },
                                            attrs: {
                                              type: "button",
                                              "data-toggle": "button",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.briefingFilter(item)
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "go-icon-16 go-icon-check",
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                        ],
                        2
                      ),
                    ]),
                  ]),
                ]),
              ]
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }